import React from 'react';
import { useApp } from '../../context/AppContext';

export const DrawnWireTotals: React.FC = () => {
  const { drawnWireTotals } = useApp();
  const { positive, negative, other, total } = drawnWireTotals;

  if (total <= 0) {
    return null;
  }

  return (
    <div
      style={{
        marginTop: '24px',
        padding: '24px',
        background: 'var(--surface)',
        borderRadius: '16px',
        border: '1px solid var(--surface-border)',
        boxShadow: 'var(--shadow-glass)',
      }}
    >
      <h2 style={{ margin: '0 0 12px 0', fontSize: '1.2rem', fontWeight: 700 }}>
        Estimated Drawn Wire Length
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.95rem' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '6px 0',
            borderBottom: '1px dashed var(--border-color)',
          }}
        >
          <span>Positive:</span>
          <strong style={{ color: '#ef4444' }}>{positive.toFixed(1)} ft</strong>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '6px 0',
            borderBottom: '1px dashed var(--border-color)',
          }}
        >
          <span>Negative:</span>
          <strong style={{ color: '#3b82f6' }}>{negative.toFixed(1)} ft</strong>
        </div>

        {other > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '6px 0',
              borderBottom: '1px dashed var(--border-color)',
            }}
          >
            <span>Other:</span>
            <strong style={{ color: 'var(--text-muted)' }}>{other.toFixed(1)} ft</strong>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: '8px',
            fontSize: '1.1rem',
          }}
        >
          <span style={{ fontWeight: 600 }}>Total Required:</span>
          <strong style={{ color: 'var(--primary)', fontWeight: 700 }}>
            {total.toFixed(1)} ft
          </strong>
        </div>
      </div>
    </div>
  );
};
